import { render, staticRenderFns } from "./DynamicLayoutField.vue?vue&type=template&id=28ca992b&"
import script from "./DynamicLayoutField.vue?vue&type=script&lang=js&"
export * from "./DynamicLayoutField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicLayoutField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports